// Single source of truth for property marker colors. The meaning of each
// color is a per-CID label stored positionally in cids.legend[legendIndex].
export const MARKER_OPTIONS = [
  { value: "blue", color: "#1976d2", legendIndex: 0, fallback: "Blue Marker" },
  { value: "red", color: "#d32f2f", legendIndex: 1, fallback: "Red Marker" },
  { value: "green", color: "#2e7d32", legendIndex: 2, fallback: "Green Marker" },
  { value: "orange", color: "#ef6c00", legendIndex: 3, fallback: "Orange Marker" },
];

export const NO_MARKER_COLOR = "#9e9e9e";

// Resolves display labels from a CID's legend array, falling back to color names.
export const markerOptionsWithLabels = (legend = []) =>
  MARKER_OPTIONS.map((option) => {
    const label = legend[option.legendIndex];
    return {
      ...option,
      label: label && label.trim().length > 0 ? label : option.fallback,
    };
  });
